/* global Vue */
import { i18n } from '../boxberryvue/src/plugins/i18n-setup';

import BootstrapVue from 'bootstrap-vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../markup/static/scss/mixins.scss';
import '../boxberryvue/src/components/App.scss';
import './styles.scss';
import WebimWidget from '../boxberryvue/src/components/WebimWidget/WebimWidget.vue';
import { actions as cityActions, mutations as cityMutations } from '../boxberryvue/src/store/city.store';
import { listenToStartSearchTrackEvent as initTrackWidgetModal } from '../boxberryvue/src/components/TrackingWidget/TrackWidgetModal.vue';
import PopupMessage from '../boxberryvue/src/components/PopupMessage/PopupMessage.vue';
import getUTMTags from '../boxberryvue/src/helpers/UTM-tags';
import mobileMountingComponent from '../boxberryvue/src/helpers/component-installer';
import VueFactory from '../boxberryvue/src/helpers/vueFactory';

try {
  if (window.location.hostname === 'u.boxberry.ru') {
    getUTMTags();
  }
} catch (e) {
  Window.console.error(e);
}
// eslint-disable-next-line
const URL_PREFIX = urlPrefix;

try {
  fetch('https://boxberry.ru/api/v1/cities/detect')
    .then((response) => response.json())
    .then((data) => {
      if (data) {
        cityMutations.setCity(data);
        cityActions.persist();
      }
    });
} catch (e) {
  Window.console.error(e);
}

Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.use(ElementUI);

window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.popup-messenger')) {
    new Vue({
      render: (h) => h(WebimWidget),
      i18n,
    }).$mount('.popup-messenger');
  }

  const BbHeaderEl = document.querySelector('#BbHeader');
  if (BbHeaderEl) {
    const BbHeader = () => import(
      /* webpackChunkName: "BbHeader023625Oct2024" */
      './components/BbHeader/BbHeader.vue'
      );
    BbHeader().then((module) => {
      mobileMountingComponent('#BbHeader')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbHeader',
          }, {}, {});
        });
    });
  }

  const BbBannerEl = document.querySelector('#BbBanner');
  if (BbBannerEl) {
    const BbBanner = () => import(
      /* webpackChunkName: "BbBanner023625Oct2024" */
      './components/BbBanner/BbBanner.vue'
      );
    BbBanner().then((module) => {
      mobileMountingComponent('#BbBanner')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbBanner',
          }, {}, {});
        });
    });
  }
  const BbPossibilitiesEl = document.querySelector('#BbPossibilities');
  if (BbPossibilitiesEl) {
    const BbPossibilities = () => import(
      /* webpackChunkName: "BbPossibilities023625Oct2024" */
      './components/BbPossibilities/BbPossibilities.vue'
      );
    BbPossibilities().then((module) => {
      mobileMountingComponent('#BbPossibilities')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbPossibilities',
          }, {}, {});
        });
    });
  }
  const BbStockEl = document.querySelector('#BbStock');
  if (BbStockEl) {
    const BbStock = () => import(
      /* webpackChunkName: "BbStock023625Oct2024" */
      './components/BbStock/BbStock.vue'
      );
    BbStock().then((module) => {
      mobileMountingComponent('#BbStock')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbStock',
          }, {}, {});
        });
    });
  }
  const BbOfferEl = document.querySelector('#BbOffer');
  if (BbOfferEl) {
    const BbOffer = () => import(
      /* webpackChunkName: "BbOffer023625Oct2024" */
      './components/BbOffer/BbOffer.vue'
      );
    BbOffer().then((module) => {
      mobileMountingComponent('#BbOffer')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbOffer',
          }, {}, {});
        });
    });
  }

  const BbAdvantagesEl = document.querySelector('#BbAdvantages');
  if (BbAdvantagesEl) {
    const BbAdvantages = () => import(
      /* webpackChunkName: "BbAdvantages023625Oct2024" */
      './components/BbAdvantages/BbAdvantages.vue'
      );
    BbAdvantages().then((module) => {
      mobileMountingComponent('#BbAdvantages')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbAdvantages',
          }, {}, {});
        });
    });
  }

  const bbCalcEl = document.querySelector('#BbCalc');
  if (bbCalcEl) {
    const BbCalc = () => import(
      /* webpackChunkName: "BbCalc023625Oct2024" */
      './components/BbCalc/BbCalc'
    );

    const params = {};
    const { countryFirst } = bbCalcEl.dataset;
    if (countryFirst) {
      params.countryFirst = countryFirst;
    }

    BbCalc().then((module) => {
      mobileMountingComponent('#BbCalc')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbCalc',
          }, {}, {
            capthcaKey: '6LcnpgEVAAAAABw1FJIJI8etqfPdtOrb8-ZADgfo',
            citieListApiUrl: `${URL_PREFIX}api/v1/cities/list`,
            calcDeliveryImApiUrl: `${URL_PREFIX}api/v1/calc/delivery_im`,
            tarifsFileApiUrl: `${URL_PREFIX}api/v1/get_documents_by_city/`,
            registerUrl: URL_PREFIX,
            lsNameItem: 'tildaCitiesList',
            ...params,
          });
        });
    });
  }

  const ecommerceMapEl = document.querySelector('#ecommerceMap');
  if (ecommerceMapEl) {
    const ecommerceMap = () => import(
      /* webpackChunkName: "ecommerceMap023625Oct2024" */
      '../boxberryvue/src/components/EcommerceMap/EcommerceMapView');

    const params = {};
    const { cityCodeForce, showBranchFilter = false } = ecommerceMapEl.dataset;
    if (cityCodeForce) {
      params.cityCodeForce = cityCodeForce;
    }

    params.showBranchFilter = showBranchFilter;

    ecommerceMap().then((module) => {
      mobileMountingComponent('#ecommerceMap')
        .then(() => {
          VueFactory(module.default, {
            el: '#ecommerceMap',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
            ...params,
          });
        });
    });
  }

  function getCalcParamsFromDataAttr(calcEl) {
    const result = {};
    if (!calcEl) return result;
    const showDocumentAgreement = !!calcEl.dataset.showDocumentAgreement;

    if (showDocumentAgreement) {
      result.showDocumentAgreement = showDocumentAgreement;
    }
    try {
      const acceptableCountiesFromData = calcEl.dataset.acceptableCountiesFrom;
      if (acceptableCountiesFromData) {
        result.acceptableCountiesFrom = acceptableCountiesFromData.trim().split(',');
      }
      const countryFromDefaultData = calcEl.dataset.countryFromDefault;
      if (countryFromDefaultData) {
        result.countryFromDefault = countryFromDefaultData;
      }
      const acceptableCountiesToData = calcEl.dataset.acceptableCountiesTo;
      if (acceptableCountiesToData) {
        result.acceptableCountiesTo = acceptableCountiesToData.trim().split(',');
      }
      const countryToDefaultData = calcEl.dataset.countryToDefault;
      if (countryToDefaultData) {
        result.countryToDefault = countryToDefaultData;
      }
      const hideWarningBelarus = !!calcEl.dataset.hideWarningBelarus;
      if (hideWarningBelarus) {
        result.hideWarningBelarus = hideWarningBelarus;
      }
      const hideFormEmail = !!calcEl.dataset.hideFormEmail;
      if (hideFormEmail) {
        result.hideFormEmail = hideFormEmail;
      }
      const hidePromocodeOption = !!calcEl.dataset.hidePromocodeOption;
      if (hidePromocodeOption) {
        result.hidePromocodeOption = hidePromocodeOption;
      }
      const hideServices = !!calcEl.dataset.hideServices;
      if (hideServices) {
        result.hideServices = hideServices;
      }
      const hideCourierWarning = !!calcEl.dataset.hideCourierWarning;
      if (hideCourierWarning) {
        result.hideCourierWarning = hideCourierWarning;
      }
      const minPrice = calcEl.dataset.minPrice;
      if (minPrice) {
        result.minPrice = minPrice;
      }
      const hrefDocsUrl = calcEl.dataset.hrefDocs;
      if (hrefDocsUrl) {
        result.hrefDocsUrl = hrefDocsUrl;
      }
      const personalAgreementLink = calcEl.dataset.personalAgreementLink;
      if (personalAgreementLink) {
        result.personalAgreementLink = personalAgreementLink;
      }
    } catch (e) {
      console.error(e);
    }

    return result;
  }

  const calculatorPIPEl = document.querySelector('#calculatorPIP');
  if (calculatorPIPEl) {
    const CalculatorPIPView = () => import(
      /* webpackChunkName: "CalculatorPIPView023625Oct2024" */
      '../boxberryvue/src/components/CalculatorPIP/CalculatorPIPView'
    );

    const calcParams = getCalcParamsFromDataAttr(calculatorPIPEl);

    CalculatorPIPView().then((module) => {
      mobileMountingComponent('#calculatorPIP')
        .then(() => {
          VueFactory(module.default, {
            el: '#calculatorPIP',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
            ...calcParams,
            hideMenu: true,
          });
        });
    });
  }

  const BbPartnersEl = document.querySelector('#BbPartners');
  if (BbPartnersEl) {
    const BbPartners = () => import(
      /* webpackChunkName: "BbPartners023625Oct2024" */
      './components/BbPartners/BbPartners.vue'
      );
    BbPartners().then((module) => {
      mobileMountingComponent('#BbPartners')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbPartners',
          }, {}, {});
        });
    });
  }
  const BbRequestFormEl = document.querySelector('#BbRequestForm');
  if (BbRequestFormEl) {
    const BbRequestForm = () => import(
      /* webpackChunkName: "BbRequestForm023625Oct2024" */
      './components/BbRequesForm/BbRequesForm.vue'
      );
    BbRequestForm().then((module) => {
      mobileMountingComponent('#BbRequestForm')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbRequestForm',
          }, {}, {
            capthcaKey: '6LcnpgEVAAAAABw1FJIJI8etqfPdtOrb8-ZADgfo',
            title: 'Подключение к Boxberry\n Для юр лиц, ИП и самозанятых',
            sendUrl: 'https://boxberry.ru/api/v1/tilda/form/join',
            citieListApiUrl: 'https://boxberry.ru/api/v1/cities/list',
            lsNameItem: 'tildaCitiesList',
          });
        });
    });
  }

  const BbFooterEl = document.querySelector('#BbFooter');
  if (BbFooterEl) {
    const BbFooter = () => import(
      /* webpackChunkName: "BbFooter023625Oct2024" */
      './components/BbFooter/BbFooter.vue'
      );
    BbFooter().then((module) => {
      mobileMountingComponent('#BbFooter')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbFooter',
          }, {}, {});
        });
    });
  }

  if (document.querySelector('#WebimWidget')) {
    new Vue({
      render: h => h(WebimWidget),
      i18n,
    }).$mount('#WebimWidget');
  }

  const mapWidgetEl = document.querySelector('#mapWidget');
  if (mapWidgetEl) {
    const MapWidget = () => import(
      /* webpackChunkName: "MapWidget023625Oct2024" */
      '../boxberryvue/src/components/MapWidget/MapWidget.vue'
      );

    const { showLinkFindOffice, linkFindOffice } = mapWidgetEl.dataset;

    MapWidget().then((module) => {
      mobileMountingComponent('#mapWidget')
        .then(() => {
          VueFactory(module.default, {
            el: '#mapWidget',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
            showLinkFindOffice: !!showLinkFindOffice,
            linkFindOffice,
          });
        });
    });
  }

  const calculatorEbayExportEl = document.querySelector('#calculatorEbayExport');
  if (calculatorEbayExportEl) {
    const CalculatorEbayExport = () => import(
      /* webpackChunkName: "CalculatorEbayExport023625Oct2024" */
      '../boxberryvue/src/components/CalculatorEbayExport/CalculatorEbayExport'
    );

    CalculatorEbayExport().then((module) => {
      mobileMountingComponent('#calculatorEbayExport')
        .then(() => {
          VueFactory(module.default, {
            el: '#calculatorEbayExport',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
          });
        });
    });
  }

  const shopCatalogEl = document.querySelector('#shop-catalog');
  if (shopCatalogEl) {
    const shopCatalog = () => import(
      /* webpackChunkName: "shopCatalog023625Oct2024" */
      '../boxberryvue/src/components/Shop/ShopCatalog.vue'
      );

    let showCountriesDefault = [];
    let showCountriesFilter = false;
    try {
      showCountriesFilter = shopCatalogEl.dataset.showCountriesFilter;
      const showCountriesFromData = shopCatalogEl.dataset.showCountries;
      if (showCountriesFromData) {
        showCountriesDefault = showCountriesFromData.split(',').map((item) => item.trim());
      }
    } catch (e) {
      console.error(e);
    }

    shopCatalog().then((module) => {
      mobileMountingComponent('#shop-catalog')
        .then(() => {
          VueFactory(module.default, {
            el: '#shop-catalog',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru',
            showCountriesDefault,
            showCountriesFilter,
          });
        });
    });
  }

  const calcWithAuthEl = document.querySelector('#calc-with-auth');
  if (calcWithAuthEl) {
    const CalcWithAuthView = () => import(
      /* webpackChunkName: "CalcWithAuth023625Oct2024" */
      '../boxberryvue/src/components/CalcWithAuth/CalcWithAuthView.vue'
    );

    const calcParams = getCalcParamsFromDataAttr(calcWithAuthEl);

    CalcWithAuthView().then((module) => {
      mobileMountingComponent('#calc-with-auth')
        .then(() => {
          VueFactory(module.default, {
            el: '#calc-with-auth',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
            ...calcParams,
            hideMenu: true,
          });
        });
    });
  }

  const formbarMobileEl = document.querySelector('#formbar-mobile');
  if (formbarMobileEl && window.innerWidth <= 1050) {
    const FormbarMobile = () => import(
      /* webpackChunkName: "FormbarMobile023625Oct2024" */
      '../boxberryvue/src/components/Formbar/FormbarMobile.vue'
    );
    const { hrefBtnFirst, hrefBtnThird } = formbarMobileEl.dataset;

    FormbarMobile().then((module) => {
      mobileMountingComponent('#formbar-mobile')
        .then(() => {
          VueFactory(module.default, {
            el: '#formbar-mobile',
          }, {}, {
            hrefBtnFirst,
            hrefBtnThird,
          });
        });
    });
  }

  const formbarDesktopEl = document.querySelector('#form-bar-desktop');
  if (formbarDesktopEl && window.innerWidth > 1050) {
    const FormbarDesktop = () => import(
      /* webpackChunkName: "FormbarDesktop023625Oct2024" */
      '../boxberryvue/src/components/Formbar/FormbarDesktop.vue'
    );
    const { hrefBtnFirst, hrefBtnThird } = formbarDesktopEl.dataset;

    FormbarDesktop().then((module) => {
      mobileMountingComponent('#form-bar-desktop')
        .then(() => {
          VueFactory(module.default, {
            el: '#form-bar-desktop',
          }, {}, {
            hrefBtnFirst,
            hrefBtnThird,
          });
        });
    });
  }

  if (document.querySelector('#initTrackWidgetModal')) {
    initTrackWidgetModal();
  }

  const calculatorImportEl = document.querySelector('#calculatorImport');
  if (calculatorImportEl) {
    const calculatorImport = () => import(
      /* webpackChunkName: "CalculatorImport023625Oct2024" */
      './components/CalculatorImport/CalculatorImport.vue'
    );

    const calcParams = getCalcParamsFromDataAttr(calculatorImportEl);

    calculatorImport().then((module) => {
      VueFactory(module.default, {
        el: '#calculatorImport',
      }, {}, {
        ...calcParams,
      });
    });
  }

  const BbContactsFormEl = document.querySelector('#BbContactsForm');
  if (BbContactsFormEl) {
    const BbContactsForm = () => import(
      /* webpackChunkName: "BbContactsForm023625Oct2024" */
      './components/BbContactsForm/BbContactsForm.vue'
      );
    BbContactsForm().then((module) => {
      mobileMountingComponent('#BbContactsForm')
        .then(() => {
          VueFactory(module.default, {
            el: '#BbContactsForm',
          }, {}, {
            capthcaKey: '6LcnpgEVAAAAABw1FJIJI8etqfPdtOrb8-ZADgfo',
            title: 'Начать работать с Boxberry',
            sendUrl: 'https://boxberry.ru/api/v1/tilda/form/join-kz',
            lsNameItem: 'tildaCitiesList'
          });
        });
    });
  }

  const mapWidgetFindEl = document.querySelector('#mapWidgetFind');
  if (mapWidgetFindEl) {
    const mapWidgetFind = () => import(
      /* webpackChunkName: "mapWidgetFind023625Oct2024" */
      '../boxberryvue/src/components/MapWidgetFind/MapWidgetFind.vue'
      );

    mapWidgetFind().then((module) => {
      mobileMountingComponent('#mapWidgetFind')
        .then(() => {
          VueFactory(module.default, {
            el: '#mapWidgetFind',
          }, {}, {
            absoluteUrl: 'https://boxberry.ru/',
            enableList: false,
            filterOnlyReceptionLaP: true,
          });
        });
    });
  }

  const successContainer = document.createElement('div');
  const containerId = `container_${Math.floor(Math.random() * 10000)}`;
  successContainer.setAttribute('id', containerId);
  document.body.appendChild(successContainer);

  new Vue({
    render: (h) => h(PopupMessage, {
      props: {
        type: containerId,
      },
    }),
    i18n,
  }).$mount(`#${containerId}`);

  const calcWithImportEl = document.querySelector('#calc-with-import');
  if (calcWithImportEl) {
    const CalcWithImport = () => import(
      /* webpackChunkName: "CalcWithImport023625Oct2024" */
      './components/CalcWithImport/CalcWithImport.vue'
    );

    const calcParams = getCalcParamsFromDataAttr(calcWithImportEl);

    CalcWithImport().then((module) => {
      mobileMountingComponent('#calc-with-import')
        .then(() => {
          VueFactory(module.default, {
            el: '#calc-with-import',
          }, {}, {
            ...calcParams,
          });
        });
    });
  }
});
